export const categories = [
  {
    id: "science",
    name: "科学认知",
    icon: "ri-flask-line",
    description:
      "用科学的角度理解自慰这一正常生理行为，澄清常见误区，解读权威研究与生理机制，帮助你在信息中找到可靠的答案。",
    accent: "primary",
  },
  {
    id: "psychology",
    name: "心理调节",
    icon: "ri-mental-health-line",
    description:
      "探讨自慰与情绪、压力、羞耻感之间的关系，学习自我接纳与正念练习，建立更健康、更从容的性心理状态。",
    accent: "secondary",
  },
  {
    id: "body",
    name: "身体照护",
    icon: "ri-heart-pulse-line",
    description:
      "从卫生、清洁到安全注意事项，了解私密部位的日常照护知识，识别身体的常见信号，学会温柔对待自己的身体。",
    accent: "accent",
  },
  {
    id: "selfcare",
    name: "自我关怀",
    icon: "ri-leaf-line",
    description:
      "自我关怀不只是身体，更是情绪与生活的平衡。这里有睡眠、饮食、放松与情绪调节的实用方法，陪你慢慢变好。",
    accent: "primary",
  },
];